const resourceCenter = {
    init() {
        // Fires before anything else happens

        this.loading = true;

        if(this.isMobile()) {
            this.hide_on_mobile = false;
        } else {
            this.hide_on_mobile = true;
        }

        // get our filters from the url params
        this.getQueryArgs();

        // Add filters to the filters object
        this.filters.type = this.urlParams.getAll('resource_type');
        this.filters.expertise = this.urlParams.getAll('expertise');

        // Get a list of all types
        this.getTypeList().then(res => {
            this.resource_types = res.body_response;

            let typeFilters = Object.values(this.filters.type);
            let resourceTypes = this.resource_types.map(type => type.name);
            this.show_resource_type_filters = typeFilters.some(filter =>
                resourceTypes.includes(filter));
        });

        // Get a list of all expertise terms
        this.getTermsList().then(res => {
            let terms = Object.fromEntries(
                Object.entries(res.body_response)
                    .filter(item => item[1].show_in_resource_center)
            );
            this.terms = terms;

            let expertiseFilters = Object.values(this.filters.expertise);
            let expertiseTerms = Object.values(this.terms).map(term => term.slug);
            this.show_expertise_filters = expertiseFilters.some(filter =>
                expertiseTerms.includes(filter));
        });


        this.getResources().then(res => {
            this.posts = res.body.posts;
            this.max_num_pages = res.body.max_num_pages;
            this.loading = false;
        });
    },

    urlParams: new URLSearchParams(),

    terms: [],

    // Array of post types to include in the resource center
    resource_types: [],

    filters: {
        "type": [],
        "expertise": [],
        "paged": 1,
        "s": ""
    },

    posts: [],

    max_num_pages: null,

    loading: false,

    show_expertise_filters: false,
    show_resource_type_filters: false,

    hide_on_mobile: false,

    isMobile() {
        return window.innerWidth < 960;
    },

    handleWindowResize() {
        if(this.isMobile()) {
            this.hide_on_mobile = false;
        } else {
            this.hide_on_mobile = true;
        }
    },

    // Get query args (e.g. filters) from the URL
    getQueryArgs() {
        const queryString = window.location.search;
        this.urlParams = new URLSearchParams(queryString);
    },

    termIsChecked(term) {
        return this.filters.expertise.includes(term.slug);
    },

    toggleTermChecked(term) {
        const url = new URL(window.location.href);

        if(this.filters.expertise.includes(term.slug)) {
            const index = this.filters.expertise.indexOf(term.slug);
            this.filters.expertise.splice(index, 1);

            let terms = url.searchParams.getAll('expertise');
            url.searchParams.delete('expertise');
            terms.forEach(_term => {
                if(_term !== term.slug) {
                    url.searchParams.append('expertise', _term);
                }
            })
        } else {
            this.filters.expertise.push(term.slug);
            url.searchParams.append('expertise', term.slug);
        }

        window.history.replaceState(null, null, url);

        this.filters.paged = 1;
        this.updatePosts();
        return this.termIsChecked(term);
    },

    clearTermFilters() {
        const url = new URL(window.location.href);

        this.filters.expertise = [];
        url.searchParams.delete('expertise');

        window.history.replaceState(null, null, url);

        this.updatePosts();
    },

    clearTypeFilters() {
        const url = new URL(window.location.href);

        this.filters.type = [];
        url.searchParams.delete('resource_type');

        window.history.replaceState(null, null, url);

        this.updatePosts();
    },

    typeIsChecked(type) {
        return this.filters.type.includes(type.name);
    },

    toggleTypeChecked(type) {
        const url = new URL(window.location.href);

        if(this.filters.type.includes(type.name)) {
            const index = this.filters.type.indexOf(type.name);
            this.filters.type.splice(index, 1);

            let types = url.searchParams.getAll('resource_type');
            url.searchParams.delete('resource_type');
            types.forEach(_type => {
                if(_type !== type.name) {
                    url.searchParams.append('resource_type', _type);
                }
            })
        } else {
            this.filters.type.push(type.name);
            url.searchParams.append('resource_type', type.name);
        }

        window.history.replaceState(null, null, url);

        this.filters.paged = 1;
        this.updatePosts();
        return this.typeIsChecked(type.name);
    },

    async getTypeList() {
        const response = await fetch('/wp-json/nomad/v1/resource-types', {
            method: "GET",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/text",
            }
        });

        return response.json();
    },

    async getTermsList() {
        const response = await fetch('/wp-json/nomad/v1/expertise', {
            method: "GET",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/text",
            }
        });

        return response.json();
    },

    async getResources() {
        const response = await fetch('/wp-json/nomad/v1/resources', {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(this.filters)
        });

        return response.json();
    },

    updatePosts() {
        this.loading = true;
        this.getResources().then(res => {
            this.posts = res.body.posts;
            this.max_num_pages = res.body.max_num_pages;
            this.loading = false;
        });
    },

    loadMorePosts() {
        this.loading = true;
        this.filters.paged++;

        this.getResources().then(res => {
            this.posts.push(...res.body.posts);
            this.max_num_pages = res.body.max_num_pages;
            this.loading = false;
        });
    }
}

export default resourceCenter;